export default __webpack_public_path__ + "static/media/searching-prior-art.33aa68a6.gif";